import { render, staticRenderFns } from "./SideNavThemeSelect.vue?vue&type=template&id=1e06c6c7"
import script from "./SideNavThemeSelect.vue?vue&type=script&lang=ts"
export * from "./SideNavThemeSelect.vue?vue&type=script&lang=ts"
import style0 from "./SideNavThemeSelect.vue?vue&type=style&index=0&id=1e06c6c7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports